import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { DotLottieVue } from '@lottiefiles/dotlottie-vue';
import loadingData from '@/assets/animated-icons/Loading_spinner_blue.json';

export default /*@__PURE__*/_defineComponent({
  __name: 'FullScreenSpinner',
  props: {
    applyOpacity: { type: Boolean, default: false }
  },
  setup(__props: any) {

const loadingIconData = loadingData as any;

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full h-full bg-racq-true-white fixed z-[1000] top-0 left-0 overflow-hidden", { 'opacity-75': _ctx.applyOpacity }])
  }, [
    _createVNode(_unref(DotLottieVue), {
      autoplay: "",
      class: "absolute top-[50%] left-[50%] translate-y-[-50%] translate-x-[-50%]",
      style: {"width":"50px","height":"50px"},
      loop: "",
      data: _unref(loadingIconData)
    }, null, 8, ["data"])
  ], 2))
}
}

})